import { useDispatch, useSelector } from "react-redux";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { useGetAssignmentsQuery } from "../../../features/assignments/assignmentsApi";
import { useGetQuizzesQuery } from "../../../features/quizzes/quizzesApi";
import VideoItem from "./VideoItem";
import { useEffect } from "react";
import { setActiveVideo } from "../../../features/videos/videosSlice";
import { selectCourseVideos } from "../../../features/videos/videoSelector";

export default function CourseVideos() {
  const { user } = useSelector((state) => state.auth);

  // const myVideos = useSelector((state) => selectCourseVideos(state, user?.id));

  // console.info('myVideos', myVideos)


  const dispatch = useDispatch()

  const { data: videos, isLoading, isError, error, } = useGetVideosQuery()

  useEffect(() => {
    if (videos?.length) {
      dispatch(setActiveVideo(videos[0]))
    }
  }, [videos])


  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {
        videos?.length ?
          videos?.map(video => <VideoItem video={video} key={video.id} />)
          : null
      }
    </div>
  )
}